// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"79d49105","455":"24d7d325","977":"b00d1691"}[chunkId] + ".chunk.js";
};